import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface QuillEditorProps {
  value: string;
  onChange: (value: string) => void;
  modules?: any;
  theme?: string;
  className?: string;
}

export const QuillEditor = React.forwardRef<ReactQuill, QuillEditorProps>(({
  value = '',
  onChange,
  modules,
  theme = 'snow',
  className = ''
}, ref) => {
  const editorRef = React.useRef<ReactQuill>(null);

  React.useImperativeHandle(ref, () => editorRef.current!, []);

  return (
    <div className={className}>
      <ReactQuill
        ref={editorRef}
        theme={theme}
        value={value}
        onChange={onChange}
        modules={modules}
        preserveWhitespace
      />
    </div>
  );
});

QuillEditor.displayName = 'QuillEditor';